import { withProps } from 'recompose';
import Item from './Item';
import { formatFloat } from '../../utils/format';

const FloatItem = withProps(({ value }) => ({ value: formatFloat(value) }))(Item);

export default FloatItem;
